import {TaskManagerStates, TaskManagerTaskColors} from '@/enum';

class Task {
    constructor(entry) {
        this.entry = entry ? entry : {};
    }
    getTaskId() {
        return this.entry.id;
    }
    getTaskName() {
        return this.entry.task;
    }
    getTaskPriority() {
        return this.entry.prio ? this.entry.prio : 0;
    }
    getIsAborting() {
        const prio = this.getTaskPriority();
        return prio == 777;
    }
    getIsAborted() {
        const prio = this.getTaskPriority();
        return prio == 778;
    }
    getIsAbortingOrAborted() {
        const prio = this.getTaskPriority();
        return prio == 777 || prio == 778;
    }
    hasError() {
        const prio = this.getTaskPriority();
        if(!prio) {
            return false;
        }
        return prio && prio == 666;
    }
    isWaiting() {
        const prio = this.getTaskPriority();
        if(!prio) {
            return false;
        }
        return prio && prio == 999;
    }
    getPipelineStateAndColor() {
        const prio = this.getTaskPriority();
        if(!prio) {
            return {
                name: 'noProcessRunning',
                color: TaskManagerTaskColors['999']
            };
        }
        if (prio >= 1 && prio <= 100) {
            return {
                name: 'Running',
                color: TaskManagerTaskColors['1']
            };
        } else {
            return {
                name: TaskManagerStates[prio],
                color: TaskManagerTaskColors[prio]
            };
        }
    }
    getPipelineState() {
        const prio = this.getTaskPriority();
        // 999 means: in queue, 1-100 means: running, 666 means: errored
        if(!prio) {
            return 'noProcessRunning';
        }
        if (prio >= 1 && prio <= 100) {
            return 'Running';
        } else {
            return TaskManagerStates[prio];
        }
    }
    getLastKnownTaskStatus() {
        return this.entry.lastKnownTaskStatus;
    }
}
export default Task;